import axios from 'axios';
import { BASE_URL } from '../src/utils/config';

const token = localStorage.getItem('token');
let headers = {};
if (token) {
    headers = {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
    };
}
let currentPracticeId = localStorage.getItem('currentPracticeId');
if (currentPracticeId) {
    headers = { ...headers, practiceId: currentPracticeId };
}
let currentPracticeRegId = localStorage.getItem('currentPracticeRegId');
if (currentPracticeRegId) {
    headers = { ...headers, practiceRegId: currentPracticeRegId };
}

let instance = axios.create({
    baseURL: BASE_URL,
    headers: headers,
});

instance.all = axios.all;
instance.spread = axios.spread;

instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === 401) {
            localStorage.clear();
            window.location = window.location.origin + '/login';
        } else {
            return error;
        }
    }
);

export function setHeader(key, value) {
    instance.defaults.headers.common[key] = value;
}

export function setAuthHeader(key, value) {
    instance.defaults.headers[key] = value;
}

export function removeHeader(key) {
    delete instance.defaults.headers.common[key];
}

export function getNewInstance(customHeaders) {
    instance = axios.create({
        baseURL: BASE_URL,
        headers: { ...headers, ...customHeaders },
    });
    return instance;
}

export function createBaseAxiosInstance() {
    const token = localStorage.getItem('token');
    let headers = {};
    if (token) {
        headers = {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        };
    }
    let currentPracticeId = localStorage.getItem('currentPracticeId');
    if (currentPracticeId) {
        headers = { ...headers, practiceId: currentPracticeId };
    }
    let currentPracticeRegId = localStorage.getItem('currentPracticeRegId');
    if (currentPracticeRegId) {
        headers = { ...headers, practiceRegId: currentPracticeRegId };
    }

    let instance = axios.create({
        baseURL: BASE_URL,
        headers: headers,
    });

    instance.all = axios.all;
    instance.spread = axios.spread;

    instance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response.status === 401) {
                localStorage.clear();
                window.location = window.location.origin + '/login';
            } else {
                return error;
            }
        }
    );

    return instance;
}

export default instance;
